import { createFileRoute } from "@tanstack/react-router";
import { PreferencesSettings } from "@/features/settings/preferences";

export const Route = createFileRoute("/_app/settings/preferences")({
  head: () => ({ meta: [{ title: "Preferences · Settings · Malfak" }] }),
  component: PreferencesSettings,
});
